export default {
  useIdToFindResourceList: {
    warning1: 'リソースはオブジェクトでなければなりません',
    warning2: 'プレフィックスは必須です',
    warning3: 'リソースタイプは必須です',
    warning4: 'カテゴリは配列でなければなりません',
    warning5: 'カテゴリIDは数値型でなければなりません',
  },
  validator: {
    message1: '圧縮ファイル内のファイル数は',
    message2:
      'zipファイル内のファイルの名前は、基本パッケージのファイル名と同じでなければなりません',
    message3: '圧縮ファイル内のファイル数は',
    message4: '圧縮ファイル内のファイルの命名が正しくありません',
    message5: '圧縮ファイル内のファイル数は',
    dragonBones: {
      errors: [
        'ドラゴンボーンファイルの拡張子は_ske.json、_tex.json、_tex.pngでなければなりません',
        'ドラゴンボーンファイルの拡張子は.ani、.json、.pngでなければなりません',
        'ドラゴンボーンファイルの拡張子は.sk、.pngでなければなりません',
      ],
      defaultError:
        'ドラゴンボーンファイルの名前またはファイル数が正しくありません',
    },
    model: {
      message1:
        'モデル構造エラー、1つのfbxには1つのメッシュしか含まれていません。',
      message2:
        'ファイルフォーマットエラー、現在の置換スポットのzipファイルには【fbx + テクスチャ】が含まれており、テクスチャはfbxとバインドされ、ソースファイルのフォーマットと一致している必要があります。',
      message3:
        'ファイルフォーマットエラー、zip形式の圧縮ファイルをアップロードしてください。',
      message4:
        'ファイルフォーマットエラー、現在の置換スポットのzipファイルには【fbx】しか含まれていません。不要なファイルを削除してください。',
      message5: 'zipファイルのサイズは1MBを超えることはできません。',
      message6:
        'ファイルフォーマットエラー、現在の置換スポットのzipファイルには【fbx + テクスチャ】が含まれており、テクスチャはfbxとバインドされ、ソースファイルのフォーマットと一致している必要があります。',
      tips: {
        modelRequirements: 'モデルの要件：',
        modelRequirementsTips: [
          '1つのfbxには1つのメッシュしか含まれていません',
          '骨構造はソースファイルと同じでなければなりません',
        ],
        fileRequirements: 'ファイル要件：',
        fileRequirementsTips: [
          '形式：zip',
          'サイズ：< 1MB',
          'zipファイル内のファイルはソースファイルと一致している必要があります',
          'zipファイル内に【fbx + テクスチャ】が含まれている場合、テクスチャはfbxとバインドされ、ソースファイルのフォーマットと一致している必要があります',
          'zipファイルが【fbx】テクスチャに当てはまらない場合、不要なファイルを削除してください',
        ],
      },
    },
  },
  categorySearch: {
    searchText: '検索コンテンツ',
    searchNotmatchTitle: '関連する結果が見つかりませんでした',
    searchNotmatchDetail:
      '申し訳ありませんが、条件に合致する結果が見つかりませんでした。異なる検索条件をお試しください。',
  },
  nav: {
    home: {
      dmaker: 'カスタムプレイアブル広告',
      gmaker: 'プレイアブル広告テンプレート',
    },
    version: 'バージョン管理',
    versionEdit: 'バージョンの編集',
    dcoVersion: 'Dcoバージョン管理',
    dcoVersionEdit: 'Dco構成',
    multiVersion: '複数の組み合わせバージョン管理',
    multiVersionEdit: '複数の組み合わせ構成',
    commonTemplate: '私の作品',
  },
  languagePacks: {
    warning: 'リポジトリ言語リストには含まれていません',
    warning1: '言語リストにはプリセットされた言語が含まれていません',
    warning2: '言語を選択してください',
    warning3: 'ファイルをアップロードしてください',
    error1: '画像の読み込みに失敗しました',
    error2: 'アップロードに失敗しました。もう一度お試しください',
    backup: 'プリセット言語',
    editText: '+編集',
    addLanguageButton: '言語の追加',
    changeLanguageButton: '言語の編集',
    saveLanguageButton: '言語の保存',
    chooseLanguage: '言語を選択してください',
    properties: {
      placeholder: '入力してください',
      required: 'テキストは空にできません',
    },
    defaultLanguage: 'デフォルト言語',
    isOpen: '言語の追加/削除機能を外部に公開しますか？',
    open: '公開',
    close: '非公開',
    tip: '作品に含まれる言語がデバイスの言語と一致しない場合、このデフォルト言語が使用されます。',
    font: 'フォント',
    fontColor: 'フォントの色',
    fontSize: 'フォントサイズ',
    borderThickness: 'ボーダー',
    borderColor: 'ボーダー色',
    bold: '太字',
    alpha: '透明度',
    italic: '斜体',
    enableShadow: 'シャドウ有効',
    shadowColor: 'シャドウの色',
    shadowBlur: 'シャドウぼかしサイズ',
    shadowOffsetX: 'シャドウオフセットX',
    shadowOffsetY: 'シャドウオフセットY',
    gradient: 'グラデーションオーバーレイ有効',
    startColor: 'グラデーションの開始色',
    endColor: 'グラデーションの終了色',
    enableGlow: '外部光を有効にする',
    glowColor: '外部光の色',
    glowBlur: '外部光のぼかしサイズ',
    enableDeleteline: '取り消し線有効',
    enableUnderline: '下線を有効にする',
    lineHeight: '行の高さ',
    letterSpacing: '文字間隔',
    confirm: '確認',
    cancel: 'キャンセル',
    add: '新規',
    update: '更新',
    language: '言語',
    uploadFile: 'ファイルをアップロード',
    languageSelectorPlaceHolder: '地域/言語を選択してください',
    only: 'アップロードできるのは',
    widthHeightTip: '幅高の制限',
    dragUploadTip:
      'ファイルをここにドラッグ＆ドロップするか、クリックしてアップロード',
    leadSession: 'ガイドステップ',
    gameSession: 'トライアルステップ',
    endSession: 'エンドステップ',
  },
  optionalGroupItem: {
    alert: '設定エラー',
    customInput: {
      placeholder: '-',
    },
    validate: {
      warning: '整数のみ入力できます',
      warning1: '入力文字数が上限を超えました',
      warning2: '入力値は0より大きい必要があります',
      warning3: '有効な正の整数を入力してください',
    },
  },
  updateResourceInZipButton: {
    text: '更新',
    error: 'extraパラメータの解析エラー',
  },
  templateMixin: {
    error: 'このカテゴリの下の構成内容が検証に合格しません',
  },
  localResourceInZipDialog: {
    title: '更新',
    tips: 'アップロードできるのは',
    rules: '幅高の制限',
    imageUploader: {
      error: '画像の読み込みに失敗しました',
    },
  },
  store: {
    error: '該当するリソースが見つかりません',
    error1: 'JSON解析エラー',
    error2: '素材のタグ設定を完了してください',
  },
  categoryConfig: {
    visible: '表示',
    hidden: '非表示',
    volume: '音量',
    cloud: 'クラウド選択',
    reset: 'リセット',
    clear: 'クリア',
    linkage: '同じ資産が存在する場合、位置が変更されます：',
  },
  readMode: '読み取り専用モード、この素材は編集中です',
  selectFinish:
    '選択が完了したら、シーン内で具体的なリソースやゲームプレイを調整してください。',
}
